import { IPayerBalance } from "../interface/ICurrentBalance";

export interface IPayerBalanceResponse {
    overDueAmount: number;
    totalAmount: number;
}

export const getResponseToState = (response: IPayerBalanceResponse): IPayerBalance => ({
    overDueAmount: response.overDueAmount,
    totalAmount: response.totalAmount,
});
